const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
//import MiniCart from './components/ui/cart/MiniCart';
import Search from './components/ui/Search';

// NAV COMPONENTS ==============================================================
import MobileNav from './components/nav/MobileNav';

export const AppComponents = {
  // Content Components ------------------------------------------------------------
  ColorMatchKit: asyncComponentFactory('content/ColorMatchKit'),
  HomeQuizHero: asyncComponentFactory('content/HomeQuizHero'),
  HomeHeroVideo: asyncComponentFactory('content/HomeHeroVideo'),
  Quiz: asyncComponentFactory('content/Quiz'),
  // PRODUCT Components ---------------------------------------------------------
  SwatchSelector: asyncComponentFactory('product/SwatchSelector'),
  ProductForm: asyncComponentFactory('product/ProductForm'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  // MEDIA Components ------------------------------------------------------------
  MediaPlayer: asyncComponentFactory('media/MediaPlayer'),

  // UI Components ------------------------------------------------------------
  Accordion: asyncComponentFactory('ui/Accordion'),
  Dropdown: asyncComponentFactory('ui/Dropdown/index.js'),
  Popup: asyncComponentFactory('ui/Popup'),
  LazyLoader: asyncComponentFactory('ui/LazyLoader'),
  MainCart: asyncComponentFactory('ui/cart/MainCart'),
  //MiniCart,
  Search,
  Tabs: asyncComponentFactory('ui/Tabs'),
  Modal: asyncComponentFactory('ui/Modal'),
  Slider: asyncComponentFactory('ui/Slider'),
  // NAV Components ------------------------------------------------------------
  MobileNav,
};
